export default {
  TYPE: {
    BONDS: 'Obligasjon',
    DERIVATIVES: 'Derivat',
    EQUITIES: 'Aksje',
    ETFS: 'ETF',
    ETNS: 'ETN',
    ETPS: 'ETP',
    RIGHT: 'Tegningsrett',
    WARRANTS: 'Warrant',
  },
  SECTOR: {
    OAX: 'Euronext Expand',
    OSE: 'Oslo Børs',
    MERK: 'Euronext Growth',
  },
};
